import { defineComponent as N, mergeModels as j, useModel as L, computed as l, createBlock as d, openBlock as a, unref as v, mergeProps as x, withModifiers as z, withCtx as F, createElementVNode as i, createCommentVNode as c, normalizeClass as s, createElementBlock as r, resolveDynamicComponent as B, toDisplayString as u } from "vue";
import { RevButtonBase as G } from "@ds/components/ButtonBase";
import { RevSpinner as I } from "@ds/components/Spinner";
import { RevTag as U } from "@ds/components/Tag";
import { omit as W } from "../../utils/omit.js";
import { tw as t } from "../../utils/tailwind.js";
import { DEFAULT_TAG_VARIANT as P } from "./Picker.constant.js";
const q = {
  key: 0,
  class: "flex w-full flex-col items-center whitespace-normal break-normal"
}, H = { class: "flex" }, J = {
  key: 1,
  class: "flex items-start whitespace-normal break-normal"
}, K = { class: "w-full" }, O = { class: "flex items-baseline justify-between" }, Q = "ml-auto body-2 text-static-default-low text-right shrink-0 max-w-[30%]", le = /* @__PURE__ */ N({
  name: "RevPicker",
  inheritAttrs: !1,
  __name: "Picker",
  props: /* @__PURE__ */ j({
    description: { default: "" },
    disabled: { type: Boolean, default: !1 },
    prefix: { default: null },
    prefixProps: { default: () => ({}) },
    label: {},
    loading: { type: Boolean, default: !1 },
    to: { default: () => {
    } },
    tag: { default: "" },
    tracking: { default: () => ({}) },
    rel: { default: "" },
    alignment: { default: "center" },
    details: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const o = L(e, "modelValue"), V = l(() => e.to ? "link" : "button"), g = l(() => e.alignment === "center"), f = l(() => o.value && !e.disabled), A = l(() => {
      const n = t`bg-static-default-low focus-visible-outline-default-hi rounded-sm relative flex w-full flex-col justify-center py-12 no-underline motion-safe:transition-colors motion-safe:duration-300 motion-safe:ease-out`, m = t`bg-static-default-low cursor-pointer hover:bg-static-default-low-hover`, b = t`border-action-default-low-pressed`, D = g.value ? t`px-12` : t`px-16`;
      return [
        !e.disabled && m,
        n,
        D,
        f.value && b
      ];
    }), S = l(() => {
      const n = t` rounded-sm absolute inset-0 motion-safe:transition-colors motion-safe:duration-300 motion-safe:ease-out`, m = t`border-picker border-action-default-low-pressed`, b = t`bg-static-default-low-disabled border-action-default-low-disabled text-static-default-low-disabled cursor-not-allowed focus:outline-none`;
      return [
        e.disabled && b,
        n,
        f.value ? m : "border border-action-default-low"
      ];
    }), E = l(
      () => t`
  absolute left-0 top-1/2 -mt-12 flex w-full place-content-center ${e.disabled ? "text-action-default-hi-disabled" : "text-action-default-hi"}
`
    ), R = l(
      () => t`
  w-full ${e.loading ? "invisible" : ""}
`
    ), h = l(() => [
      t`body-1`,
      e.prefix && t`shrink`,
      e.disabled && t`text-static-default-hi-disabled`,
      o.value ? t`body-1-bold` : t`body-1`,
      f.value && t`text-action-default-hi-pressed`,
      !o.value && !e.disabled && t`text-action-default-hi`
    ]), k = l(() => [
      t`body-2 mt-4`,
      !e.disabled && t`text-static-default-mid`,
      e.disabled && t`text-static-default-hi-disabled`
    ]), w = l(() => W(e.prefixProps, "class")), y = l(() => [
      "mr-8",
      t`h-24 shrink-0`,
      !o.value && !e.disabled && t`text-action-default-hi`,
      f.value && t`text-action-default-hi-pressed`,
      e.disabled && t`text-action-default-hi-disabled`,
      e.prefixProps.class
    ]), M = l(
      () => t`
  absolute ${e.alignment === "left" ? "-top-10 right-12" : "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 -rotate-3"}
`
    ), C = l(() => typeof e.tag == "string" ? e.tag : e.tag?.label), T = l(
      () => typeof e.tag == "string" ? P : e.tag?.variant ?? P
    );
    function $() {
      o.value = !o.value;
    }
    return (n, m) => (a(), d(v(G), x(n.$attrs, {
      class: A.value,
      disabled: e.disabled,
      rel: e.rel,
      role: V.value,
      to: e.to,
      tracking: e.tracking,
      onClick: z($, ["prevent"])
    }), {
      default: F(() => [
        i("div", {
          class: s(E.value)
        }, [
          e.loading ? (a(), d(v(I), {
            key: 0,
            "aria-hidden": ""
          })) : c("", !0)
        ], 2),
        i("div", {
          class: s(S.value)
        }, null, 2),
        i("div", {
          class: s(R.value)
        }, [
          g.value ? (a(), r("div", q, [
            i("div", H, [
              (a(), d(B(e.prefix), x({ class: "" }, w.value, { class: y.value }), null, 16, ["class"])),
              i("span", {
                class: s(h.value)
              }, u(e.label), 3)
            ]),
            e.description ? (a(), r("div", {
              key: 0,
              class: s(k.value)
            }, u(e.description), 3)) : c("", !0)
          ])) : (a(), r("div", J, [
            (a(), d(B(e.prefix), x(w.value, { class: y.value }), null, 16, ["class"])),
            i("div", K, [
              i("div", O, [
                i("p", {
                  class: s(["mr-4 text-left", h.value])
                }, u(e.label), 3),
                e.details ? (a(), r("p", {
                  key: 0,
                  class: s(Q)
                }, u(e.details), 1)) : c("", !0)
              ]),
              e.description ? (a(), r("p", {
                key: 0,
                class: s(["text-left", k.value])
              }, u(e.description), 3)) : c("", !0)
            ])
          ]))
        ], 2),
        C.value ? (a(), d(v(U), {
          key: 0,
          class: s(M.value),
          label: C.value,
          variant: T.value
        }, null, 8, ["class", "label", "variant"])) : c("", !0)
      ]),
      _: 1
    }, 16, ["class", "disabled", "rel", "role", "to", "tracking"]));
  }
});
export {
  le as default
};
